<script setup lang="ts">
import { computed, ref } from 'vue'

import { Coordinates, soccerPitchConfig } from '@collector/shared-ui-domain'
import SoccerPitchSvg from '@collector/shared-ui-domain/assets/soccer/pitch.svg'
import PenaltyOverlay from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PenaltyOverlay/PenaltyOverlay.vue'
import Pitch from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/Pitch/Pitch.vue'
import BallPosition from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchWithChangePossession/BallPosition/BallPosition.vue'
import {
  useBallCoordinates,
  useFieldCoordinatesIncident,
  usePossessionSvg,
} from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchWithChangePossession/composables'
import PointOutIncidentBallPosition from '@desktop/views/Relation/Sports/components/RelationView/Main/PitchWithIncidents/PitchWithChangePossession/PointOutIncidentBallPosition/PointOutIncidentBallPosition.vue'

import BallImg from './BallPosition/ball.svg'

// composables
const { possessionHomeSvg, possessionAwaySvg } = usePossessionSvg()
const { isBallCoordinatesVisible, ballCoordinates } = useBallCoordinates()
const { sendFieldCoordinatesIncident } = useFieldCoordinatesIncident()

// state
const isPointOutIncidentBallPositionVisible = ref<boolean>()
const isPenaltyOverlayVisible = ref<boolean>()
const pointOutIncidentClickedCoordinates = ref<Coordinates | null>(null)

// computed
const possessionHomeSrc = computed(() =>
  isPointOutIncidentBallPositionVisible.value
    ? undefined
    : possessionHomeSvg.value,
)

const possessionAwaySrc = computed(() =>
  isPointOutIncidentBallPositionVisible.value
    ? undefined
    : possessionAwaySvg.value,
)

const pitchImageClass =
  'max-h-[clamp(5.5rem,calc(100dvh-41rem),12rem)] @2md:max-h-[clamp(16rem,calc(100dvh-27rem),22rem)]'

// methods
function onFieldClickCoordinates(
  event: MouseEvent,
  coordinates: Coordinates,
): void {
  if (isPointOutIncidentBallPositionVisible.value) {
    pointOutIncidentClickedCoordinates.value = coordinates
  } else {
    // eslint-disable-next-line no-console
    console.debug(
      'sendFieldCoordinatesIncident',
      JSON.stringify(coordinates),
      +new Date(),
    )

    sendFieldCoordinatesIncident(event, coordinates)
  }
}
</script>

<template>
  <Pitch
    v-bind="soccerPitchConfig"
    class="@2md:py-4 @2md:px-2 flex-1 px-1 py-2"
    :pitchImageSrc="SoccerPitchSvg"
    :pitchImageClass
    :possessionHomeSrc
    :possessionAwaySrc
    :isPitchStatusOverlaysOnBottom="isPenaltyOverlayVisible"
    @fieldClickCoordinates="onFieldClickCoordinates"
  >
    <template #overlays>
      <BallPosition
        v-if="
          isBallCoordinatesVisible && !isPointOutIncidentBallPositionVisible
        "
        :ballSrc="BallImg"
        :coordinates="ballCoordinates"
      />
      <PointOutIncidentBallPosition
        v-model:coordinates="pointOutIncidentClickedCoordinates"
        :ballSrc="BallImg"
        @visible="isPointOutIncidentBallPositionVisible = $event"
      />
      <PenaltyOverlay @visible="isPenaltyOverlayVisible = $event" />
    </template>
  </Pitch>
</template>
